import {getApiMetadataWithoutToken} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {IUpdateMemexItemRequest, UpdateMemexItemResponse} from './contracts'

export async function apiUpdateItem(body: IUpdateMemexItemRequest): Promise<UpdateMemexItemResponse> {
  const apiData = getApiMetadataWithoutToken('memex-item-update-api-data')

  const {data} = await fetchJSONWith<UpdateMemexItemResponse>(apiData.url, {
    method: 'PUT',
    body,
  })
  return data
}
